import React, { useState, useEffect } from "react";
import "./serieRevisionFlex.scss";
import InputOutlined from "./../../Forms/InputOutlined";
import fetchApiData from "../../apiHandlers/fetchApiData";
import {
  setVeiculeInfos,
  setVeiculeKilo,
  CurrentStepSetAction,
  setCodePasForAnnualService,
} from "./../../../actions/action";
import { connect } from "react-redux";
import CONSTANTS from "../../../constants";
import Select from "../../Forms/Select";
import vinImage from "../../../images/AP/vininfo-illustration.jpg";
import PopUp from "../../popup/popup";
import Button from "../../Forms/Button";

const mapStateToProps = (state) => state;
const mapDispatchToProps = {
  setVeiculeInfos,
  setVeiculeKilo,
  CurrentStepSetAction,
  setCodePasForAnnualService,
};

const SerieRevisionFlex = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showKilometrage, setShowKilometrage] = useState(false);
  const [showVinField, setShowVinField] = useState(true);
  const [loading, setLoading] = useState(false);
  const [serieInput, setSerieInput] = useState(
    props.store.car.SerialNumber ? props.store.car.SerialNumber : ""
  );
  const [serieCodeError, setSerieCodeError] = useState(false);
  const [kilometrageData, setKilometrageData] = useState([]);
  const [showInfosSerie, setShowInfosSerie] = useState(false);
  const isRecallCampagneActivate = !!Number(
    window.siteConfig.ActivateRecallCampaign
  );

  useEffect(() => {
    if (
      props.store.car.SerialNumber !== undefined &&
      props.store.car.SerialNumber.length
    )
      checkSerieCode();
  }, [serieInput]);

  const checkSerieCode = () => {
    const CarDetails = new fetchApiData();
    setLoading(true);

    CarDetails.getSerie(serieInput)
      .then((data) => {
        switch (data.d.ErrorCode) {
          case 0:
            if (
              isRecallCampagneActivate &&
              props.store.car.SerialNumber !== undefined &&
              !props.store.car.SerialNumber.length
            )
              checkCampRapEligibility(serieInput);
            props.setVeiculeInfos(data.d.VehicleInfo);

            setLoading(false);
            setSerieCodeError("");
            setShowKilometrage(true);
            setShowVinField(false);
            loadPas();
            break;
          default:
            setSerieCodeError(data.d.ErrorMessage);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        console.log("fait: ", error);
        setLoading(false);
      });
  };

  const checkCampRapEligibility = () => {
    const cpRappelData = new fetchApiData();
    cpRappelData
      .getCompagneRappelEligibility(serieInput)
      .then((data) => {
        if (data.d.Eligible) {
          setShowPopup(true);
        }
      })
      .catch((error) => {
        console.log("fait: ", error);
      });
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const loadPas = () => {
    const pasForfaits = new fetchApiData();
    setLoading(true);

    pasForfaits
      .getPas({
        geoID: props.store.dealer.geoID,
        mileage: props.store.kilo.kilometrage,
        vin: serieInput,
      })
      .then((data) => {
        let listPas = [];
        listPas[""] = CONSTANTS.LABELS.needs_basket_maintenance_label5;
        data.d.map(function(value) {
          listPas[value.Value] = value.Text;
        });
        setKilometrageData(listPas);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error getPas : ", error);
      });
  };

  return (
    <div className="rootRevisionBodyContainer">
      <div
        className="revisionTitle"
        dangerouslySetInnerHTML={{
          __html: CONSTANTS.LABELS.needs_basket_maintenance_label1,
        }}
      ></div>

      <div className="vinInputContainer">
        <div
          dangerouslySetInnerHTML={{
            __html: CONSTANTS.LABELS.needs_basket_maintenance_label2,
          }}
          className="vinInputTitle"
        ></div>
        <div className="inputIconContainer">
          <div className="inputErrorContainer">
            <InputOutlined
              placeholder={
                props.store.car.SerialNumber !== undefined &&
                props.store.car.SerialNumber.length
                  ? props.store.car.SerialNumber
                  : CONSTANTS.LABELS.needs_basket_maintenance_label3
              }
              onChange={(e) => {
                setSerieInput(
                  e.target.value.trim().length ? e.target.value : ""
                );
              }}
              isDisabled={
                props.store.car.SerialNumber !== undefined &&
                props.store.car.SerialNumber.length
                  ? true
                  : false
              }
              isInvalid={serieCodeError}
              value={serieInput}
            />
          </div>

          <div className="iconContainer">
            <div
              className={
                showInfosSerie
                  ? "revisionIconInfo isClicked"
                  : "revisionIconInfo"
              }
              name="info"
              tabIndex="0"
              onKeyDown={(e) =>
                e.key === "Enter" && setShowInfosSerie(!showInfosSerie)
              }
              onClick={(e) => setShowInfosSerie(!showInfosSerie)}
            ></div>
            {showInfosSerie && (
              <div className="revisionPopup">
                <div>{CONSTANTS.LABELS.needs_basket_maintenance_help1}</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: CONSTANTS.LABELS.needs_basket_maintenance_help2,
                  }}
                ></div>
                <img src={vinImage} />
              </div>
            )}
          </div>
        </div>
        {!showKilometrage && (
          <Button
            onClick={() => checkSerieCode()}
            Disabled={serieInput.length < 8}
          >
            {CONSTANTS.LABELS.common_v2_nextstep}
          </Button>
        )}
      </div>
      {showKilometrage && (
        <div className="kilometrageInputContainer">
          <div
            className="kilometrageInputTitle"
            dangerouslySetInnerHTML={{
              __html: CONSTANTS.LABELS.needs_basket_maintenance_label4,
            }}
          ></div>
          <Select
            customClassName={"selectDropdown"}
            Options={kilometrageData}
            Name={CONSTANTS.LABELS.needs_basket_km}
            onChange={(e) => {
              props.setCodePasForAnnualService(e.target.value);
              props.fillPasSelect({
                selected: e.target.value,
                listPas: kilometrageData,
              });
              props.vinSuccess(true);
            }}
            Inverse={true}
          />
        </div>
      )}
      {showPopup && (
        <PopUp
          title={CONSTANTS.LABELS.vehicule_step2recalleligibility}
          content={CONSTANTS.LABELS.vehicule_step2recalleligibilitycontent}
          primaryButtonLabel={
            CONSTANTS.LABELS.vehicule_step2recalleligibilityagreement
          }
          handlePrimaryButton={() => closePopup()}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SerieRevisionFlex);
